export const environment = {
    serviceHostName: 'https://app-texasshowpass-dev.azurewebsites.net',
    adminServiceHostName: 'https://app-texasshowpass-dev.azurewebsites.net',
    turnstileSiteKey: '',
    appInsights: {
        enabled: false,
        instrumentationKey: '60c60c41-3a18-4da9-adc8-e1f4abf3a5dc'
    },
    /** Feature flag: Use API-based validation (DivisionClassValidation) instead of hardcoded rules */
    useApiValidation: true
};